const viewModel = {
  shape
};

function formatDate(dateValue) {
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) {
    return '';
  }
  const day = String(date.getDate()).padStart(2, '0');
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

function shape(data) {
  const dataObj = data?.data;
  const orders = dataObj?.orders || [];
  return orders.map((order, index) => {
    if (!order) return { id: `empty-order-${index}` };
    return {
      ...order,
      id: order.id || `order-${index}`,
      title: order.title,
      created: formatDate(order.created),
      direction: getDirection(order.from),
      price: formatPrice(order.price),
      weight: formatWeight(order.weight),
      circles: getCircles(order),
      packages: (order.packages || []).map((pkg, pIndex) =>
        shapePackage(pkg, pIndex)
      )
    };
  });
}

function getCircles(order) {
  return (order?.packages || [])
    .map(pkg => {
      if (!pkg) return { isGreen: false };
      const status = pkg.status || pkg['Status (from Couriers)'];
      const isStatusGreen =
        status === 'Посылка готова к выдаче' || status === 'Посылка выдана';
      const isPaymentStatusGreen = pkg.paymentStatus === 'Оплачено';
      const isGreen = isStatusGreen && isPaymentStatusGreen;
      return { isGreen };
    })
    .sort((a, b) => a.isGreen - b.isGreen);
}

function shapePackage(pkg, index) {
  if (!pkg) return { id: `empty-pkg-${index}` };
  const status = pkg.status || pkg['Status (from Couriers)'];
  return {
    ...pkg,
    id: pkg.id || `pkg-${index}`,
    title: pkg.title,
    price: formatPrice(pkg.price),
    weight: formatWeight(pkg.weight),
    statusColor: getStatusColor(status),
    status: transformStatus(status),
    paymentStatusColor: getPaymentStatusColor(pkg.paymentStatus),
    paymentStatus: pkg.paymentStatus
  };
}

function formatWeight(value) {
  if (value === null || value === undefined || value === '') return '—';
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return num.toLocaleString('ru-RU', { style: 'decimal' }) + '\xa0г';
}

function formatPrice(value) {
  if (value === null || value === undefined || value === '') return '—';
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return num.toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
}

function transformStatus(status) {
  switch (status) {
    case 'Посылка принята от клиента':
      return 'Принято';
    case 'Посылка готова к выдаче':
      return 'Готово к выдаче';
    case 'Посылка выдана':
      return 'Выдано';
    default:
      return status;
  }
}

function getStatusColor(status) {
  switch (status) {
    case 'Посылка принята от клиента':
      return 'neutral';
    case 'Посылка выдана':
      return 'success';
    case 'В пути':
      return 'neutral';
    default:
      return 'neutral';
  }
}

function getPaymentStatusColor(status) {
  switch (status) {
    case 'Не оплачено':
      return 'neutral';
    case 'Оплачено':
      return 'success';
    default:
      return 'neutral';
  }
}

function getDirection(from) {
  switch (from) {
    case 'Бали':
      return 'Бали – Москва';
    case 'Москва':
      return 'Москва – Бали';
    default:
      return from;
  }
}

export default viewModel;
